<div *ngIf="(regionsWithActivation()?.length ?? 0) === 0" class="text-muted small">
	Keine Bereiche definiert
</div>
<div *ngIf="(regionsWithActivation()?.length ?? 0) > 0">
	<div class="d-flex align-items-center">
		<div class="d-flex flex-wrap gap-1 align-items-start flex-grow-1">
			<button *ngFor="let r of regionsWithActivation(); let i=index"
				class="btn btn-sm btn-outline-dark region-button"
				[title]="getRegionName(i)"
				(click)="onClick(r)"><i class="bi bi-textarea-resize"></i><span class="region-name">{{getRegionName(i)}}</span></button>
		</div>
		<button class="btn btn-sm btn-outline-secondary ms-2"
			title="Auf alle Bereiche zoomen"
			(click)="zoomToAll()"><i class="bi bi-arrows-fullscreen"></i></button>
	</div>
</div>
<input style="display: none" type="file" onclick="this.value = null" (change)="onGeoJsonFileAdded($event)" accept=".geojson,.json,.gpkg,.zip,.7z,.shp,.dbf,.prj,.shx" multiple #geoJsonFileInput>
<input style="display: none" type="file" onclick="this.value = null" (change)="onShapefileCompanionsAdded($event)" accept=".dbf,.prj,.shx" multiple #shapefileCompanionsInput>
